import { configureStore } from "@reduxjs/toolkit";
import ShoplineReducer from "./slice/shopline";

export const store = configureStore({
  reducer: {
    shopline: ShoplineReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;